import React from "react";
import { Link } from 'react-router-dom';
import Header from "../section_components/Header";
import Footer from "../section_components/Footer";
import BuyLEOSBox from "../section_components/BuyLEOSBox";
import TokenInfo from "../section_components/TokenInfo";
import TokenSaleInfo from "../section_components/TokenSaleInfo";
import ShadowBox from "../section_components/ShadowBox";
import SaleRoundTable from "../section_components/SaleRoundTable";
import UseDocumentTitle from "../section_components/UseDocumentTitle";

// <---------- img start ---------->
import symbol_icon from "../img/COIN-org.png";
import taylorwessinglogo from "../img/taylorwessing-logo.png";
import Brightnodelogo from "../img/brightnode-logo.png";
import chatgpticon from "../img/chatgpt-icon.png";
// <---------- img end ---------->


// <------- TokenInfoData data start ---------->
const TokenInfoData = [
    {
        id: 1,
        TokenInfoName: "Network",
        TokenInfoAnswer:  "Pangea (explorer)"
    },
    {
        id: 2,
        TokenInfoName: "Ticker",
        TokenInfoAnswer:  "LEOS"
    },
    {
        id: 3,
        TokenInfoName: "Total supply",
        TokenInfoAnswer:  "50,000,000,000"
    },
    {
        id: 4,
        TokenInfoName: "Inflation",
        TokenInfoAnswer:  "0.0% (none)"
    },
    {
        id: 5,
        TokenInfoName: "TGE Circulating Supply",
        TokenInfoAnswer:  "3,000,000 (12.5%)"
    },
    {
        id: 6,
        TokenInfoName: "Fully Diluted Valuation",
        TokenInfoAnswer:  "$100,000,000"
    },
]
// <------- TokenInfoData data end ---------->

// <------- tokensale info data start ---------->
const TokenSaleInfoData = [
    {
        id: 1,
        Title: "Sale starts",
        Detail:  "1 April 2024"
    },
    {
        id: 2,
        Title: "Sale ends",
        Detail:  "30 April 2024"
    },
    {
        id: 3,
        Title: "Sale amount",
        Detail:  "2,500,000 (1.25%)"
    },
    {
        id: 4,
        Title: "Minimum raise amount",
        Detail:  "$1,200,000"
    },
    {
        id: 5,
        Title: "Maximum raise amount",
        Detail:  "$2,200,000"
    },
    {
        id: 6,
        Title: "Raised",
        Detail:  "$600,000 (3 payments)"
    }
]
// <------- tokensale info data end ---------->

// <------- Sale Round Data start ---------->
const SaleRoundTableData = [
    {
        id: 1,
        title: "Seed",
        startdate:  "April 2024",
        fdv:  "$100,000,000",
        price:  "$0.002",
        allocation:  "2.5%",
    },
    {
        id: 2,
        title: "Strategic Partnership",
        startdate:  "October 2024",
        fdv:  "$200,000,000",
        price:  "$0.004",
        allocation:  "5.5%",
    },
    {
        id: 3,
        title: "Public (TGE)",
        startdate:  "February 2025",
        fdv:  "$600,000,000",
        price:  "$0.012",
        allocation:  "7.0%",
    }
]
// <------- Sale Round Data end ---------->


export default function Home() {

    UseDocumentTitle('LEOS Sales Plateform - Pangea');

    return(
        <>
            <div className="main-wapper home-page-wapper">
                <Header/>
                <section className="section about-leos-section">
                    <div className="section-bg  two-space ">
                        <div className="container">
                            <div className="row gy-3 align-items-center">
                                <div className="col-lg-8 col-12">
                                    <div className="item-box caption-box d-flex flex-column gap-5">
                                        <div className="item-box-bar d-flex flex-column  gap-lg-5 gap-4">
                                            <div className="item-box-item d-flex flex-sm-row flex-column align-items-center text-sm-start text-center gap-sm-4 gap-3">
                                                <div className="coin-icon-bar">
                                                    <img src={symbol_icon} alt="" />
                                                </div>
                                                <div className="text-caption d-flex flex-column gap-3">
                                                    <h2>LEOS (Ƚ)</h2>
                                                    <div className="icon-text-bar d-flex align-items-center gap-sm-4 gap-2">
                                                        <div className="icon-text-item d-flex align-items-center gap-1">
                                                            <div className="icon-bar">
                                                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M5.32487 9.32667H4.6582V10.66H5.32487V9.32667ZM13.3249 10.66H13.9915V9.32667H13.3249V10.66ZM5.32487 13.324H4.6582V14.6573H5.32487V13.324ZM13.3249 14.6667H13.9915V13.3333H13.3249V14.6667ZM5.32487 5.32933H4.6582V6.66267H5.32487V5.32933ZM10.6582 6.66667H11.3249V5.33333H10.6582V6.66667ZM13.3249 0.666667L13.7969 0.194667L13.6009 0H13.3249V0.666667ZM17.3249 4.66667H17.9915V4.39067L17.7969 4.19467L17.3249 4.66667ZM5.32487 10.66H13.3249V9.32667H5.32487V10.66ZM5.32487 14.6573L13.3249 14.6667V13.3333L5.32487 13.324V14.6573ZM5.32487 6.66267L10.6582 6.66667V5.33333L5.32487 5.32933V6.66267ZM15.9915 18.6667H2.6582V20H15.9915V18.6667ZM1.99154 18V2H0.658203V18H1.99154ZM2.6582 1.33333H13.3249V0H2.6582V1.33333ZM16.6582 4.66667V18H17.9915V4.66667H16.6582ZM12.8529 1.13867L16.8529 5.13867L17.7969 4.19467L13.7969 0.194667L12.8529 1.13867ZM2.6582 18.6667C2.48139 18.6667 2.31182 18.5964 2.1868 18.4714C2.06177 18.3464 1.99154 18.1768 1.99154 18H0.658203C0.658203 18.5304 0.868917 19.0391 1.24399 19.4142C1.61906 19.7893 2.12777 20 2.6582 20V18.6667ZM15.9915 20C16.522 20 17.0307 19.7893 17.4058 19.4142C17.7808 19.0391 17.9915 18.5304 17.9915 18H16.6582C16.6582 18.1768 16.588 18.3464 16.4629 18.4714C16.3379 18.5964 16.1683 18.6667 15.9915 18.6667V20ZM1.99154 2C1.99154 1.82319 2.06177 1.65362 2.1868 1.5286C2.31182 1.40357 2.48139 1.33333 2.6582 1.33333V0C2.12777 0 1.61906 0.210714 1.24399 0.585786C0.868917 0.960859 0.658203 1.46957 0.658203 2H1.99154Z" fill="#201827"/>
                                                                </svg>
                                                            </div>
                                                            <p><Link to="https://pangea-web4-world.webflow.io/whitepapers" >Whitepapers</Link></p>
                                                        </div>
                                                        <div className="icon-text-item d-flex align-items-center gap-1">
                                                            <div className="icon-bar">
                                                            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M17.1189 5.11016C16.2494 4.63672 15.0807 4.29609 13.7939 4.13594V3.5625C13.7939 2.61562 13.0455 1.75781 11.6846 1.14609C10.4471 0.588281 8.80957 0.28125 7.0752 0.28125C5.34082 0.28125 3.70332 0.588281 2.46582 1.14609C1.10488 1.75781 0.356445 2.61562 0.356445 3.5625V6.6875C0.356445 7.63438 1.10488 8.49219 2.46582 9.10391C3.28535 9.47266 4.2791 9.72891 5.35645 9.86406V10.4375C5.35645 11.3844 6.10488 12.2422 7.46582 12.8539C8.70332 13.4117 10.3408 13.7188 12.0752 13.7188C13.8096 13.7188 15.4471 13.4117 16.6846 12.8539C18.0432 12.2422 18.7939 11.3844 18.7939 10.4375V7.3125C18.7939 6.48047 18.1994 5.69844 17.1189 5.11016ZM16.6705 5.93359C17.4354 6.35 17.8564 6.84375 17.8564 7.3125C17.8564 8.42109 15.4822 9.65625 12.0752 9.65625C11.5212 9.65659 10.9677 9.62162 10.4182 9.55156C10.8513 9.43537 11.2747 9.2857 11.6846 9.10391C13.0432 8.49219 13.7939 7.63438 13.7939 6.6875V5.08047C14.9189 5.23125 15.9268 5.52812 16.6705 5.93359ZM8.0252 8.99844C7.71895 9.01953 7.4002 9.03125 7.0752 9.03125C6.66113 9.03125 6.2627 9.0125 5.88145 8.97891C5.87183 8.9781 5.86216 8.9781 5.85254 8.97891C5.57285 8.95312 5.30566 8.91875 5.04395 8.87734V6.69688C5.71653 6.79541 6.39543 6.8445 7.0752 6.84375C7.75496 6.8445 8.43386 6.79541 9.10645 6.69688V8.875C8.76738 8.92891 8.41035 8.97031 8.03691 8.99687L8.0252 8.99844ZM12.8564 5.27266V6.6875C12.8564 7.43281 11.7822 8.23437 10.0439 8.68047V6.51953C10.6069 6.39244 11.1563 6.21139 11.6846 5.97891C12.1047 5.79643 12.4988 5.55893 12.8564 5.27266ZM7.0752 1.21875C10.4822 1.21875 12.8564 2.45391 12.8564 3.5625C12.8564 4.67109 10.4822 5.90625 7.0752 5.90625C3.66816 5.90625 1.29395 4.67109 1.29395 3.5625C1.29395 2.45391 3.66816 1.21875 7.0752 1.21875ZM1.29395 6.6875V5.27266C1.65175 5.55784 2.04581 5.79428 2.46582 5.97578C2.99406 6.20827 3.54348 6.38931 4.10645 6.51641V8.67734C2.36816 8.23438 1.29395 7.43281 1.29395 6.6875ZM6.29395 10.4375V9.94687C6.55176 9.96094 6.81191 9.96875 7.0752 9.96875C7.38301 9.96875 7.68665 9.95912 7.98613 9.93984C8.35257 10.0721 8.72669 10.1819 9.10645 10.2687V12.4305C7.36816 11.9844 6.29395 11.1828 6.29395 10.4375ZM10.0439 12.625V10.4453C10.7165 10.5444 11.3954 10.594 12.0752 10.5938C12.755 10.5945 13.4339 10.5454 14.1064 10.4469V12.625C12.7603 12.8333 11.3901 12.8333 10.0439 12.625ZM15.0439 12.4305V10.2695C15.6069 10.1424 16.1563 9.96139 16.6846 9.72891C17.1046 9.5474 17.4986 9.31096 17.8564 9.02578V10.4375C17.8564 11.1828 16.7822 11.9844 15.0439 12.4305Z" fill="#201827"/>
                                                                </svg>
                                                            </div>
                                                            <p><Link to="https://pangea-web4-world.webflow.io/tokenomics" >Tokenomics</Link></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item-box-item d-flex align-items-center justify-content-sm-start justify-content-center gap-sm-0 gap-3">
                                                <div className="text-caption d-flex flex-column gap-2 text-center ps-0 px-sm-4 px-3 border-end">
                                                    <span>0.002 $</span>
                                                    <p className="m-w">Price in USD</p>
                                                </div>
                                                <div className="text-caption d-flex flex-column gap-2 text-center px-sm-4">
                                                    <span>100%</span>
                                                    <p className="m-w">Remaining Tokens</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item-box-bar d-flex flex-column gap-lg-4 gap-3">
                                            <h3 className="text-capitalize">About LEOS</h3>
                                            <div className="text-caption-p d-flex flex-column gap-sm-4 gap-3">
                                                <p>Your investment in LEOS tokens is not just a transaction; it's a step toward innovation in a shared future. Early stage LEOS adopters get premium access to currency prices and Pangea opportunities while supporting a social impact project of a massive scale.</p>
                                                <p>Your investment in LEOS tokens is not just a transaction; it's a step toward innovation in a shared future. Early stage LEOS adopters get premium access to currency prices and Pangea opportunities while supporting a social impact project of a massive scale.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-12">
                                    <BuyLEOSBox/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section token-information-section">
                    <div className="section-bg bot-space">
                        <div className="container">
                        <div className="token-information-box d-flex flex-column gap-lg-5 gap-4 align-items-center text-center">
                                <div className="heading-box d-flex flex-column gap-2 w-100">
                                    <h2 className="text-uppercase">Token</h2>
                                </div>
                                <ul className="d-flex flex-column gap-2 align-items-center text-center m-0 p-0 information-listing">
                                    {TokenInfoData.map((element)=>{
                                        return(
                                            <li className="d-flex align-items-center gap-1" key={element.id}>
                                                <TokenInfo Name={element.TokenInfoName} Answer={element.TokenInfoAnswer} />
                                            </li>
                                        )
                                    })}
                                </ul>
                                <div className="shadow-box-wapper w-100">
                                    <div className="row gy-3">
                                        <div className="col-md-6 col-12">
                                            <ShadowBox
                                                ContractTitle= "Token contract"
                                                TokenName= "eosio.token"
                                                TokenUrl= "https://explorer.pangea.web4.world/account/eosio.token"
                                                GithubUrl= "https://github.com/Tonomy-Foundation/Tonomy-Contracts/tree/master/contracts/eosio.token"
                                            />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <ShadowBox
                                                ContractTitle= "Vesting contract"
                                                TokenName= "vesting.tmy"
                                                TokenUrl= "https://explorer.pangea.web4.world/account/vestng.token"
                                                GithubUrl= "https://github.com/Tonomy-Foundation/Tonomy-Contracts/tree/master/contracts/vestng"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section saleround-table-section">
                    <div className="section-bg bot-space">
                        <div className="container">
                            <div className="table-wapper">
                                <div className="table-responsive">
                                    <table className="table m-0">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Start Date</th>
                                                <th>FDV</th>
                                                <th>Price</th>
                                                <th>Allocation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {SaleRoundTableData.map((element)=>{
                                                return(
                                                    <SaleRoundTable 
                                                        Title={element.title} 
                                                        StartDate={element.startdate}
                                                        Fdv={element.fdv}
                                                        Price={element.price}
                                                        Allocation={element.allocation}
                                                    />
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section token-sale-section">
                    <div className="section-bg bot-space">
                        <div className="container">
                            <div className="token-sale-box d-flex flex-column gap-lg-5 gap-4 align-items-center text-center">
                                <div className="heading-box d-flex flex-column gap-2 w-100">
                                    <h2 className="Forest_Green_text">Token sale</h2>
                                    <span className="Ocean_Blue_text">Sale round: Seed</span>
                                </div>
                                <div className="row g-lg-3 g-2 tokensale-info-listing w-100">
                                    {TokenSaleInfoData.map((element)=>{
                                        return(
                                            <div className="col-md-4 col-sm-6 col-12" key={element.id}>
                                                <TokenSaleInfo TokeninfoTitle={element.Title} TokeninfoDetails={element.Detail} />
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className="token-unlock-caption d-flex align-items-center Digital_Gold_bg w-100 gap-3">
                                    <div className="icon-bar">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 16V10C6 7.34784 7.05357 4.8043 8.92893 2.92893C10.8043 1.05357 13.3478 0 16 0C18.6522 0 21.1957 1.05357 23.0711 2.92893C24.9464 4.8043 26 7.34784 26 10C26 11.1 25.1 12 24 12C22.9 12 22 11.1 22 10C22 8.4087 21.3679 6.88258 20.2426 5.75736C19.1174 4.63214 17.5913 4 16 4C14.4087 4 12.8826 4.63214 11.7574 5.75736C10.6321 6.88258 10 8.4087 10 10V16H28C29.0609 16 30.0783 16.4214 30.8284 17.1716C31.5786 17.9217 32 18.9391 32 20V36C32 37.0609 31.5786 38.0783 30.8284 38.8284C30.0783 39.5786 29.0609 40 28 40H4C2.93913 40 1.92172 39.5786 1.17157 38.8284C0.421427 38.0783 0 37.0609 0 36V20C0 18.9391 0.421427 17.9217 1.17157 17.1716C1.92172 16.4214 2.93913 16 4 16H6ZM4 20V36H28V20H4ZM20 24H24V32H20V24Z" fill="white"/>
                                        </svg>
                                    </div>
                                    <div className="text-caption d-flex flex-column gap-2 flex-grow-1 text-start">
                                        <span className="text-white">Token unlocks:</span>
                                        <p className="text-white"> 25% 6 months after Token Generation Event (Public Sale), 4.17% monthly till two years</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section bot-space features-section">
                    <div className="section-bg two-space">
                        <div className="container">
                            <div className="row gy-3 features-listing-box">
                                <div className="col-md-7 col-12">
                                    <div className="row g-lg-4 gy-3">
                                        <div className="col-12">
                                            <div className="item-box bg-white d-flex flex-column gap-sm-4 gap-3">
                                                <div className="img-bar">
                                                    <img src={taylorwessinglogo} alt="" />  
                                                </div>
                                                <div className="caption d-flex flex-column gap-2">
                                                    <p>International law firm  <Link to="https://www.taylorwessing.com/en/" target="_blank" className="text-decoration-underline Ocean_Blue_text">Taylor Wessing</Link> reviewed and guided the launch of the Pangea virtual nation and regulation compliant LEOS sale</p>
                                                    <Link className="link-arrow-text d-flex align-items-center gap-1" to="https://www.taylorwessing.com/en/" target="_blank">
                                                        <p className="text capitalize Forest_Green_text">Read more</p>
                                                        <div className="icon-bar">
                                                        <svg width="22" height="13" viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15.326 0.1875L14.3176 1.19596L18.5961 5.47444H0V6.90069H18.5959L14.3176 11.179L15.326 12.1875L21.3261 6.1875L15.326 0.1875Z" fill="#4CAF50"/>
                                                            </svg>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                        <div className="item-box bg-white d-flex flex-column gap-sm-4 gap-3">
                                                <div className="img-bar">
                                                    <img src={Brightnodelogo} alt="" />  
                                                </div>
                                                <div className="caption d-flex flex-column gap-2">
                                                    <p>Swiss Tokenomics speialist  <Link to="https://brightnode.io/" target="_blank" className="text-decoration-underline Ocean_Blue_text">Brightnode</Link> has conducted a full Tokenomics and Vesting audit of LEOS. </p>
                                                    <Link className="link-arrow-text d-flex align-items-center gap-1" to="https://brightnode.io/" target="_blank">
                                                        <p className="text capitalize Forest_Green_text">Read more</p>
                                                        <div className="icon-bar">
                                                        <svg width="22" height="13" viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15.326 0.1875L14.3176 1.19596L18.5961 5.47444H0V6.90069H18.5959L14.3176 11.179L15.326 12.1875L21.3261 6.1875L15.326 0.1875Z" fill="#4CAF50"/>
                                                            </svg>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 col-12">
                                    <div className="chatgpt-box d-flex flex-column align-items-center text-center justify-content-center gap-4">
                                        <div className="logo-caption w-100">
                                            <img src={chatgpticon} alt="" />
                                        </div>
                                        <h3 className="text capitalize text-white w-100">ChatGPT</h3>
                                        <p className="w-100 px-3 text-white">Ask me anything about <br /> Pangea and LEOS</p>
                                        <div className="btn-box d-flex flex-column align-items-center bg-black pt-3 px-3 w-100 gap-3">
                                            <h5 className="text capitalize text-white">Pangea GPT</h5>
                                            <Link to="https://chat.openai.com/g/g-difrS9Q4y-pangea-gpt-guide" className="fill-btn d-flex align-items-center gap-1 Ocean_Blue_bg rounded-top rounded-0">
                                                <span>Use Pangea GPT Guide</span>
                                                <div className="icon-bar">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10ZM20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM7.3175 13.5038C7.20031 13.6211 7.04129 13.6871 6.87544 13.6872C6.70959 13.6873 6.55048 13.6216 6.43313 13.5044C6.31577 13.3872 6.24977 13.2282 6.24965 13.0623C6.24954 12.8965 6.31531 12.7374 6.4325 12.62L11.5538 7.5H8.09375C7.92799 7.5 7.76902 7.43415 7.65181 7.31694C7.5346 7.19973 7.46875 7.04076 7.46875 6.875C7.46875 6.70924 7.5346 6.55027 7.65181 6.43306C7.76902 6.31585 7.92799 6.25 8.09375 6.25H13.0625C13.2283 6.25 13.3872 6.31585 13.5044 6.43306C13.6217 6.55027 13.6875 6.70924 13.6875 6.875V11.8438C13.6875 12.0095 13.6217 12.1685 13.5044 12.2857C13.3872 12.4029 13.2283 12.4688 13.0625 12.4688C12.8967 12.4688 12.7378 12.4029 12.6206 12.2857C12.5033 12.1685 12.4375 12.0095 12.4375 11.8438V8.38375L7.3175 13.5038Z" fill="white"/>
                                                    </svg>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer/>
            </div>
        </>
    )
}